import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useSelector } from "react-redux";
import { RootStateType } from "@Store";
import { IAuthRouteProps } from "@Interfaces";

export const PrivateRoute = ({ component: Component }: IAuthRouteProps) => {
    const isAuthenticated = useSelector(
        (state: RootStateType) => state.auth.isAuthenticated
    );
    const location = useLocation();

    if (isAuthenticated) {
        return <Component />;
    }

    return (
        <Navigate
            to="/login"
            replace
            state={{ from: location }} //if not auth go back to login
        />
    );
};

export default PrivateRoute;
